<template>
<div class="about container" id="about">
    <div class="row">
        <div class="col-lg-6 col-md-6 d-flex justify-content-center">
            <img data-aos="fade" data-aos-duration="1000"
            data-aos-anchor-placement="top-center" src="../../public/images/about-hero.png" alt="">
        </div>
        <div class="col-lg-6 col-md-6 about-text">
            <h3 data-aos="fade-left" data-aos-duration="800"
            data-aos-anchor-placement="top-center" data-aos-delay="100">About</h3>
            <hr data-aos="fade-left" data-aos-duration="800"
            data-aos-anchor-placement="center-center" data-aos-delay="150">
            <p data-aos="fade-left" data-aos-duration="800"
            data-aos-anchor-placement="center-center" data-aos-delay="200"> 
            I'm a informatic engineering student at Mercubuana University.
            I'm a self taught Website Developer.
            I have experience developing website using Bootstrap,
            JQuery library, and Codeigniter. I also have
            experience in developing website using vue.js framework.
            I have interest to be front-end developer.
            I took an online courses in <a href="https://buildwithangga.com/">buildwithangga.com</a>
            and <a href="https://dicoding.com/">dicoding.com</a>
            such as Vanilla Javascript for Website Development, Learn Basic Web Programming, and
            Vue Javascript framework.</p>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'About'
}
</script>

<style lang="scss" scoped>
.about {
    width: 100%;
    padding: 0px 50px;
    .row {
        img {
            transform: scale(0.65) !important;
        }
        .about-text {
            padding: 20% 0%;
        }
        @media (max-width: 767.8px) {
            img {
                display: none;
            }
        }
    }
}
</style>
